import React from 'react';
import { Modal } from 'react-bootstrap-5';
import ContactForm from '../../contacts/form/contact_form';
import { createContact } from '../../../helpers/prospect_api';
import type { Contact } from 'bundles/connect/types';

type Props = {
  onHide: () => void;
  onPushContact: (contact: Contact) => void;
}

export default function CreateModal({ onHide, onPushContact }: Props) {

  const handleSaveContact = ({ contact }) => {
    createContact(contact).then((response) => {
      onPushContact(response['connect/person'] || response['connect/company']);
      onHide();
    });
  };

  return (
    <Modal show onHide={onHide}>
      <Modal.Header className="border-bottom-0" closeButton>
        <Modal.Title as="h5">New Contact</Modal.Title>
      </Modal.Header>
      <ContactForm
        type="Connect::Person"
        onCancel={onHide}
        onSave={handleSaveContact}
      />
    </Modal>
  );
}
